import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import dayjs from 'dayjs';
import saveAs from 'file-saver';
import { write, utils } from 'xlsx';

import ExpenseReportComponent from '../../components/expenses/ExpenseReportComponent';
import { ExpenseStatus } from '../../modules/expenses';
import { getExpenseStat2, getPrimeContractStat } from '../../api/constlink';
import { priceToString, s2ab } from '../../util/utils';
import { Alert } from 'antd';
import { InvoiceStatus } from '../../modules/invoices';
import { RootState } from '../../modules';

interface ReportListPLContainerProps {
  enterpriseId: string;
  projectId: string;
}

function ReportListPLContainer({
  match,
}: RouteComponentProps<ReportListPLContainerProps>) {
  const [alertMsg, setAlertMsg] = useState<any>();
  const [visualData1, setVisualData1] = useState<any[]>();
  const [visualData2, setVisualData2] = useState<any>();
  const [visualData3, setVisualData3] = useState<any[]>();
  const [visualData4, setVisualData4] = useState<any[]>();
  const [visualData6, setVisualData6] = useState<any>();

  const project = useSelector(
    (state: RootState) => state.projects.project.data,
  );

  const dispatch = useDispatch();
  const { enterpriseId, projectId } = match.params;

  const [expenses, setExpenses] = useState<any[]>();
  const [invoices, setInvoices] = useState<any[]>();
  const [approvingInvoices, setApprovingInvoices] = useState<any[]>();
  const [contracts, setContracts] = useState<any[]>();

  useEffect(() => {
    (async () => {
      const data = await getExpenseStat2({
        enterpriseId,
        projectId,
        filterData: {
          // startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
          // expenseEndDate: dayjs()
          //   .endOf('month')
          //   .add(1, 'day')
          //   .format('YYYY-MM-DD'),
          // invoiceEndDate: dayjs().endOf('month').format('YYYY-MM-DD'),
          expenseStatus: ExpenseStatus.SUBMITTED,
          status: InvoiceStatus.APPROVED,
          hotFix: 'true',
        },
      });
      setExpenses(data.expenses);
      setInvoices(data.invoices);
      setApprovingInvoices(data.approvingInvoices);
    })();
  }, [dispatch, enterpriseId, projectId]);

  useEffect(() => {
    (async () => {
      const _contracts = await getPrimeContractStat({
        enterpriseId,
        projectId,
      });
      setContracts(_contracts);
    })();
  }, [dispatch, enterpriseId, projectId]);

  useEffect(() => {
    if (
      expenses === undefined ||
      invoices === undefined ||
      approvingInvoices === undefined ||
      contracts === undefined ||
      project === null
    )
      return;

    // console.log(expenses);
    // console.log(invoices);
    // console.log(contracts);

    const vendorCompanyList = [];
    for (let i = 0; i < invoices.length; i++) {
      vendorCompanyList.push({
        key: i,
        type: invoices[i].vendor.type,
        name: invoices[i].vendor.application.general.name,
        gongjong: invoices[i].gongjong,
        category: invoices[i].category,
        value: invoices[i].price - invoices[i].vat,
        price: invoices[i].price,
        paymentAmount: invoices[i].payments.reduce(
          (acc: number, cur: any) => acc + cur.amount,
          0,
        ),
        valuePerArea: project.area
          ? (invoices[i].price - invoices[i].vat) / project.area
          : null,
      });
    }
    setVisualData4(vendorCompanyList);

    let categoryList = [];
    for (let i = 0; i < expenses.length; i++) {
      categoryList.push(expenses[i].category);
    }
    for (let i = 0; i < invoices.length; i++) {
      categoryList.push(invoices[i].category);
    }
    const categorySet = new Set(categoryList);
    categoryList = Array.from(categorySet);
    let result = [];
    for (let i = 0; i < categoryList.length; i++) {
      let price = 0;
      for (let j = 0; j < expenses.length; j++) {
        if (expenses[j].category === categoryList[i])
          price += expenses[j].price - expenses[j].vat;
      }
      for (let j = 0; j < invoices.length; j++) {
        if (invoices[j].category === categoryList[i])
          price += invoices[j].price - invoices[j].vat;
      }
      result.push({ key: i, type: categoryList[i], value: price });
    }
    setVisualData1(result);

    let contractPrice = 0;
    let changeOrderPrice = 0;
    let totalExpensePrice = 0;
    for (let i = 0; i < contracts.length; i++) {
      contractPrice += contracts[i].priceData.priceData.supplyPrice;
      for (let j = 0; j < contracts[i].changeOrders.length; j++) {
        changeOrderPrice +=
          contracts[i].changeOrders[j].priceData.priceData.supplyPrice;
      }
    }
    for (let i = 0; i < result.length; i++) {
      totalExpensePrice += result[i].value;
    }
    const totalContractPrice = contractPrice + changeOrderPrice;
    const profit = totalContractPrice - totalExpensePrice;
    setVisualData2({
      contractPrice,
      changeOrderPrice,
      totalContractPrice,
      totalExpensePrice,
      profit,
    });

    let gongjongList = [];
    for (let i = 0; i < expenses.length; i++) {
      gongjongList.push(expenses[i].gongjong);
    }
    for (let i = 0; i < invoices.length; i++) {
      gongjongList.push(invoices[i].gongjong);
    }
    let gongjongSet = new Set(gongjongList);
    gongjongList = Array.from(gongjongSet);

    // console.log(expenses);
    // console.log(invoices);
    // console.log(gongjongList);
    // console.log(gongjongSet);

    result = [];
    for (let i = 0; i < gongjongList.length; i++) {
      let price = 0;
      for (let j = 0; j < expenses.length; j++) {
        if (expenses[j].gongjong === gongjongList[i])
          price += expenses[j].price - expenses[j].vat;
      }
      for (let j = 0; j < invoices.length; j++) {
        if (invoices[j].gongjong === gongjongList[i])
          price += invoices[j].price - invoices[j].vat;
      }
      result.push({ key: i, type: gongjongList[i], value: price });
    }
    for (let i = 0; i < result.length; i++) {
      if (result[i].type === null) result[i].type = '미분류';
    }
    // console.log(result);
    setVisualData3(result);

    /**
     * 정산현황 상세표
     */

    gongjongList = [];
    let isInvoiceEnabled: boolean = false;
    if (contracts.length === 0) {
      setVisualData6({ isInvoiceEnabled, items: [] });
      return;
    }
    for (let i = 0; i < expenses.length; i++) {
      gongjongList.push(expenses[i].gongjong);
    }
    const allInvoices = [...invoices, ...approvingInvoices];
    for (let i = 0; i < allInvoices.length; i++) {
      gongjongList.push(allInvoices[i].gongjong);
    }

    if (allInvoices.length > 0) isInvoiceEnabled = true;

    if (contracts[0].priceData.isComplex === true) {
      for (
        let j = 0;
        j < contracts[0].priceData.priceData.directCosts.length;
        j++
      ) {
        gongjongList.push(contracts[0].priceData.priceData.directCosts[j].name);
      }
    }

    for (let k = 0; k < contracts[0].changeOrders.length; k++) {
      if (contracts[0].changeOrders[k].priceData.isComplex === true) {
        for (
          let l = 0;
          l <
          contracts[0].changeOrders[k].priceData.priceData.directCosts.length;
          l++
        ) {
          gongjongList.push(
            contracts[0].changeOrders[k].priceData.priceData.directCosts[l]
              .name,
          );
        }
      }
    }

    gongjongList.push('기타금액');
    gongjongList.push('미분류');
    gongjongSet = new Set(gongjongList);
    gongjongList = Array.from(gongjongSet);
    gongjongList = gongjongList.filter((item) => item !== null);

    // console.log(gongjongSet);
    // console.log(gongjongList);

    result = [];
    for (let i = 0; i < gongjongList.length; i++) {
      const tempArr = [];
      if (gongjongList[i] === '미분류') {
        for (let j = 0; j < expenses.length; j++) {
          if (expenses[j].gongjong === null)
            tempArr.push({
              type: 'E',
              price: expenses[j].price - expenses[j].vat,
              category: expenses[j].category,
              note: `${dayjs(expenses[j].usedDateTime).format(
                'YYYY-MM-DD HH:mm:ss',
              )} | ${priceToString(expenses[j].price - expenses[j].vat)} | ${
                expenses[j].category ?? ''
              } | ${expenses[j].description ?? ''}`,
            });
        }
        for (let j = 0; j < allInvoices.length; j++) {
          if (allInvoices[j].gongjong === null)
            tempArr.push({
              type: 'I',
              status: allInvoices[j].status,
              price: allInvoices[j].price - allInvoices[j].vat,
              category: allInvoices[j].category,
              note: `${dayjs(allInvoices[j].billingDate).format(
                'YYYY-MM-DD',
              )} | ${priceToString(
                allInvoices[j].price - allInvoices[j].vat,
              )} | ${allInvoices[j].category ?? ''} | ${
                allInvoices[j].description ?? ''
              }`,
            });
        }

        if (contracts[0].priceData.isComplex === false) {
          tempArr.push({
            type: 'P',
            price: contracts[0].priceData.priceData.supplyPrice,
            note: '',
          });
        }

        for (let k = 0; k < contracts[0].changeOrders.length; k++) {
          if (contracts[0].changeOrders[k].priceData.isComplex === false)
            tempArr.push({
              type: 'C',
              price:
                contracts[0].changeOrders[k].priceData.priceData.supplyPrice,
              note: `${
                contracts[0].changeOrders[k].changeDate
              } | ${priceToString(
                contracts[0].changeOrders[k].priceData.priceData.supplyPrice,
              )}`,
            });
        }

        result.push({ key: i, gongjong: gongjongList[i], data: [...tempArr] });
      } else if (gongjongList[i] === '기타금액') {
        if ('totalIndirectCosts' in contracts[0].priceData.priceData) {
          tempArr.push({
            type: 'P',
            price: contracts[0].priceData.priceData.totalIndirectCosts,
            note: '',
          });
        }

        for (let k = 0; k < contracts[0].changeOrders.length; k++) {
          if (
            'totalIndirectCosts' in
            contracts[0].changeOrders[k].priceData.priceData
          )
            tempArr.push({
              type: 'C',
              price:
                contracts[0].changeOrders[k].priceData.priceData
                  .totalIndirectCosts,
              note: `${
                contracts[0].changeOrders[k].changeDate
              } | ${priceToString(
                contracts[0].changeOrders[k].priceData.priceData
                  .totalIndirectCosts,
              )}`,
            });
        }
        result.push({ key: i, gongjong: gongjongList[i], data: [...tempArr] });
      } else {
        for (let j = 0; j < expenses.length; j++) {
          if (expenses[j].gongjong === gongjongList[i])
            tempArr.push({
              type: 'E',
              price: expenses[j].price - expenses[j].vat,
              category: expenses[j].category,
              note: `${dayjs(expenses[j].usedDateTime).format(
                'YYYY-MM-DD HH:mm:ss',
              )} | ${priceToString(expenses[j].price - expenses[j].vat)} | ${
                expenses[j].category ?? ''
              } | ${expenses[j].description ?? ''}`,
            });
        }
        for (let j = 0; j < allInvoices.length; j++) {
          if (allInvoices[j].gongjong === gongjongList[i])
            tempArr.push({
              type: 'I',
              status: allInvoices[j].status,
              price: allInvoices[j].price - allInvoices[j].vat,
              category: allInvoices[j].category,
              note: `${dayjs(allInvoices[j].billingDate).format(
                'YYYY-MM-DD',
              )} | ${priceToString(
                allInvoices[j].price - allInvoices[j].vat,
              )} | ${allInvoices[j].category ?? ''} | ${
                allInvoices[j].description ?? ''
              }`,
            });
        }

        if (contracts[0].priceData.isComplex === true) {
          for (
            let j = 0;
            j < contracts[0].priceData.priceData.directCosts.length;
            j++
          ) {
            if (
              contracts[0].priceData.priceData.directCosts[j].name ===
              gongjongList[i]
            )
              tempArr.push({
                type: 'P',
                price: contracts[0].priceData.priceData.directCosts[j].price,
                note: '',
              });
          }
        }

        for (let k = 0; k < contracts[0].changeOrders.length; k++) {
          if (contracts[0].changeOrders[k].priceData.isComplex === true) {
            for (
              let j = 0;
              j <
              contracts[0].changeOrders[k].priceData.priceData.directCosts
                .length;
              j++
            ) {
              if (
                contracts[0].changeOrders[k].priceData.priceData.directCosts[j]
                  .name === gongjongList[i]
              )
                tempArr.push({
                  type: 'C',
                  price:
                    contracts[0].changeOrders[k].priceData.priceData
                      .directCosts[j].price,
                  note: `${
                    contracts[0].changeOrders[k].changeDate
                  } | ${priceToString(
                    contracts[0].changeOrders[k].priceData.priceData
                      .directCosts[j].price,
                  )}`,
                });
            }
          }
        }
        result.push({ gongjong: gongjongList[i], data: [...tempArr] });
      }
    }

    // console.log(result);
    setVisualData6({ isInvoiceEnabled, items: [...result] });
  }, [expenses, invoices, approvingInvoices, contracts, project]);

  const downloadContractReport = async () => {
    // console.log(visualData1);
    // console.log(visualData2);

    if (contracts === undefined || contracts === null) return;

    if (contracts.length === 0) {
      setAlertMsg({
        message: '도급계약 정보가 존재하지 않아 보고서를 생성할 수 없습니다.',
        type: 'error',
      });
      return;
    }
    if (contracts[0].priceData.isComplex === false) {
      setAlertMsg({
        message:
          '도급계약 내역서(집계) 가 존재 할 경우에만 보고서를 생성할 수 있습니다.',
        type: 'warning',
      });
      return;
    }

    let gongjongList = [];
    for (let i = 0; i < contracts.length; i++) {
      for (
        let j = 0;
        j < contracts[i].priceData.priceData.directCosts.length;
        j++
      ) {
        gongjongList.push(contracts[i].priceData.priceData.directCosts[j].name);
      }
      for (let k = 0; k < contracts[i].changeOrders.length; k++) {
        for (
          let l = 0;
          l <
          contracts[i].changeOrders[k].priceData.priceData.directCosts.length;
          l++
        ) {
          // console.log(l);
          // console.log(
          //   contracts[i].changeOrders[k].priceData.priceData.directCosts,
          // );
          gongjongList.push(
            contracts[i].changeOrders[k].priceData.priceData.directCosts[l]
              .name,
          );
        }
      }
    }
    const gongjongSet = new Set(gongjongList);
    gongjongList = Array.from(gongjongSet);

    const arr5: any[] = [];

    for (let m = 0; m < gongjongList.length; m++) {
      const tempArr: any[] = [];
      tempArr.push(gongjongList[m]);

      for (let i = 0; i < contracts.length; i++) {
        let costIndex = -1;
        for (
          let k = 0;
          k < contracts[i].priceData.priceData.directCosts.length;
          k++
        ) {
          if (
            gongjongList[m] ===
            contracts[i].priceData.priceData.directCosts[k].name
          )
            costIndex = k;
        }
        if (costIndex !== -1)
          tempArr.push(
            contracts[i].priceData.priceData.directCosts[costIndex].price,
          );
        else tempArr.push(0);
        // console.log(contracts[i].id);
        for (let j = 0; j < contracts[i].changeOrders.length; j++) {
          costIndex = -1;
          for (
            let k = 0;
            k <
            contracts[i].changeOrders[j].priceData.priceData.directCosts.length;
            k++
          ) {
            if (
              gongjongList[m] ===
              contracts[i].changeOrders[j].priceData.priceData.directCosts[k]
                .name
            )
              costIndex = k;
          }
          if (costIndex !== -1)
            tempArr.push(
              contracts[i].changeOrders[j].priceData.priceData.directCosts[
                costIndex
              ].price,
            );
          else tempArr.push(0);
          // console.log(contracts[i].changeOrders[j].id);
        }
        arr5.push(tempArr);
      }
    }

    const arr6: any[] = ['항목'];
    for (let i = 0; i < contracts.length; i++) {
      arr6.push('도급금액');
      for (let j = 0; j < contracts[i].changeOrders.length; j++) {
        arr6.push(`설변(${contracts[i].changeOrders[j].changeDate})`);
      }
    }
    arr6.push('합계');

    // console.log(arr6);
    // console.log(arr5);

    for (let i = 0; i < arr5.length; i++) {
      let val = 0;
      for (let j = 1; j < arr6.length - 1; j++) {
        val += arr5[i][j];
      }
      arr5[i].push(val);
    }

    // console.log(arr5);

    const valArr: any[] = [
      ['집계내역 합계', 'totalDirectCosts'],
      ['기타금액', 'totalIndirectCosts'],
      ['공급가액', 'supplyPrice'],
      ['부가세', 'vat'],
      ['총공사비', 'totalPrice'],
    ];
    const arr8: any[] = [];
    for (let m = 0; m < valArr.length; m++) {
      for (let i = 0; i < contracts.length; i++) {
        const tempArr: any[] = [];
        tempArr.push(valArr[m][0]);
        tempArr.push(contracts[i].priceData.priceData[valArr[m][1]]);
        for (let j = 0; j < contracts[i].changeOrders.length; j++) {
          tempArr.push(
            contracts[i].changeOrders[j].priceData.priceData[valArr[m][1]],
          );
        }
        arr8.push(tempArr);
      }
    }
    for (let i = 0; i < arr8.length; i++) {
      let val = 0;
      for (let j = 1; j < arr6.length - 1; j++) {
        val += arr8[i][j];
      }
      arr8[i].push(val);
    }
    // console.log(arr8);
    const totalArr: any[] = [];
    totalArr.push(arr6);
    totalArr.push(...arr5);
    totalArr.push(...arr8);
    // console.log(totalArr);

    var wb = utils.book_new();
    const ws = await utils.json_to_sheet(totalArr, { skipHeader: true });
    utils.book_append_sheet(wb, ws, `계약현황`);
    const wbout = write(wb, { bookType: 'xlsx', type: 'binary' });
    saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      `공사계약현황_${dayjs().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
    );
  };

  return (
    <>
      {alertMsg && (
        <Alert
          message={`${alertMsg.message}`}
          type={
            alertMsg.type === 'error'
              ? 'error'
              : alertMsg.type === 'warning'
              ? 'warning'
              : 'info'
          }
          closable
          style={{ marginTop: '5px', marginBottom: '5px' }}
        />
      )}
      {visualData1 &&
        visualData2 &&
        visualData3 &&
        visualData4 &&
        visualData6 && (
          <ExpenseReportComponent
            visualData1={visualData1}
            visualData2={visualData2}
            visualData3={visualData3}
            visualData4={visualData4}
            visualData6={visualData6}
            downloadContractReport={downloadContractReport}
          />
        )}
    </>
  );
}

export default ReportListPLContainer;
